import React, { useEffect } from 'react';
import
{
    Box,
    Typography,
    Avatar,
    Divider,
    Button,
} from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
//import { useEventState } from '../../stores/eventStore';
import { v1 as uuidv1 } from 'uuid';
import { ChromePicker } from 'react-color';
import ColorizeIcon from '@mui/icons-material/Colorize';
import eventUpload from '../../assets/images/eventUpload.png';
import { generatePath, useHistory } from 'react-router-dom';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { createState, useState, Downgraded } from '@hookstate/core';
import { useThemeState, setTheme } from '../../hookState/ThemeState';
import { makeStyles } from '@mui/styles';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import DefaultEvent from '../../assets/images/default_event.jpg';

const useStyles = makeStyles(() => ({
    itemRoot: {
        textAlign: 'left',
    },
    buttonContent: {
        margin: '8px',
    },
    pic: {
        width: '310px',
        height: '180px',
        marginLeft: 1,
    },
    buttonColor: {
        width: '62px',
        height: '62px',
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const eventState = createState({
    eventName: '',
    eventLocation: '',
    eventNotes: '',
    eventStatus: 1,
    eventColor: '',
    picUrl: '',
    picture: '',
    src: '',
});

const BrandingColor = () =>
{
    const classes = useStyles();
    const history = useHistory();
    const state = useState(eventState);
    const loading = useState(false);
    const disableButton = useState(false);
    const themeState = useThemeState();

    const [showPrimaryColorPicker, setShowPrimaryColorPicker] =
        React.useState(false);
    const [showSecondaryColorPicker, setShowSecondaryColorPicker] =
        React.useState(false);
    const [primaryColor, setPrimaryColor] = React.useState(
        themeState.primary.value
    );
    const [secondaryColor, setSecondaryColor] = React.useState(
        themeState.secondary.value
    );
    const [eventPic, setEventPic] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const [eventID, setEventID] = React.useState(0);

    const resetState = () =>
    {
        state.set({
            eventName: '',
            eventLocation: '',
            eventNotes: '',
            eventStatus: 1,
            eventColor: '',
            picUrl: '',
            picture: '',
            src: '',
        });
        setEventID(0);
        setEventPic('');
        setPrimaryColor(themeState.primary.value);
        setSecondaryColor(themeState.secondary.value);
        setSnackBarProps({
            openSnack: false,
            variant: 'error',
            message: '',
        });
    };

    useEffect(() =>
    {
        const eventInfo1 = Helper.getStorage('eventInfo');
        if (eventInfo1.eventID)
        {
            state.src.set('');
            setEventID(eventInfo1.eventID);
            const color = JSON.parse(eventInfo1.color);
            const imageURL = eventInfo1.eventImageUrl;
            state.picUrl.set(eventInfo1.imageUrl);
            // state.picture.set(eventInfo1.imageUrl);
            if (eventInfo1.eventImageUrl != '')
                setEventPic(imageURL);
            else
                setEventPic(DefaultEvent);

            setPrimaryColor(color.primary);
            setSecondaryColor(color.secondary);
        } else
        {
            resetState(eventInfo1);
        }
    }, [eventID]);


    const handleCancel = () =>
    {
        history.push(generatePath(RouteConstants.EVENT_DETAIL, { eventID: eventID }));
    };

    const handleClick = async (event) =>
    {
        event.preventDefault();
        const userInfo = Helper.getStorage('userInfo');
        let localStorageEventInfo = Helper.getStorage('eventInfo');

        let eventInfo = {
            EventID: localStorageEventInfo.eventID,

            EventName: localStorageEventInfo.eventName,
            Notes: localStorageEventInfo.notes,
            StartDate: localStorageEventInfo.startDate,
            EndDate: localStorageEventInfo.endDate,
            Color: JSON.stringify({
                primary: primaryColor,
                secondary: secondaryColor,
            }),
            // ImageUrl: imageReq.picUrl,
            Venue: localStorageEventInfo.venue,
            Status: localStorageEventInfo.status,
            CreatedBy: userInfo ? userInfo.userID : 1,
        };

        let eventForm = new FormData();
        eventForm.append('EventID', localStorageEventInfo.eventID);
        eventForm.append('EventName', localStorageEventInfo.eventName);
        eventForm.append('Notes', localStorageEventInfo.notes);
        eventForm.append('StartDate', localStorageEventInfo.startDate);
        eventForm.append('EndDate', localStorageEventInfo.endDate);
        eventForm.append('Color', JSON.stringify({ primary: primaryColor, secondary: secondaryColor }));
        eventForm.append('OldImageUrl', state.picUrl.get() ? state.picUrl.get() : '');
        eventForm.append('ImageUrl', state.picture.attach(Downgraded).get() ? state.picture.attach(Downgraded).get().name : (state.picUrl.get() ? state.picUrl.get() : ''));
        eventForm.append('Venue', localStorageEventInfo.venue);
        eventForm.append('Status', localStorageEventInfo.status);
        eventForm.append('CreatedBy', userInfo ? userInfo.userID : 1);
        eventForm.append('ImageSource', state.picture.attach(Downgraded).get());

        let snackBarProp = { ...snackBarProps };
        // if (eventInfo.ImageUrl === '') {
        //     setSnackBarProps({
        //         ...snackBarProp,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please upload  Actual Event Image',
        //     });
        //     return false;
        // }
        loading.set(true);
        disableButton.set(true);
        ApiHelper.post(APIURLConstants.POST_EVENT_BRANDING_INFO, eventForm)
            .then((res) =>
            {
                if (res.data)
                {
                    snackBarProp.variant = 'success';
                    snackBarProp.message =
                        'Event Branding updated successfully';
                    snackBarProp.openSnack = true;
                    setSnackBarProps(snackBarProp);

                    localStorageEventInfo.color = eventInfo.Color;
                    localStorageEventInfo.eventImageUrl = res.data.eventImageUrl;
                    localStorageEventInfo.imageUrl = state.picture.attach(Downgraded).get() ? state.picture.attach(Downgraded).get().name : (state.picUrl.get() ? state.picUrl.get() : '');
                    localStorageEventInfo.createdBy = eventInfo.CreatedBy;
                    Helper.setStorage('eventInfo', localStorageEventInfo);
                    setTheme(localStorageEventInfo);

                    setTimeout(() =>
                    {
                        resetState();
                        history.push(RouteConstants.DASHBOARD);
                        disableButton.set(false);
                    }, 2000);
                } else
                {
                    disableButton.set(false);
                    setSnackBarProps({
                        ...snackBarProp,
                        openSnack: true,
                        variant: 'error',
                        message: 'This event name already exists',
                    });
                }
                loading.set(false);
            })
            .catch((error) =>
            {
                loading.set(false);
                disableButton.set(false);

                if (error.response && error.response.status === 401)
                {
                    snackBarProp.variant = 'error';
                    snackBarProp.message = 'Access denied';
                } else
                {
                    snackBarProp.variant = 'error';
                    snackBarProp.message =
                        'Error while updating event Branding Color';
                }
                snackBarProp.openSnack = true;
                setSnackBarProps(snackBarProp);
            });
    };
    const fileUploadHandler = (event) =>
    {
        let file = event.target.files[0];
        let blob = file.slice(0, file.size, file.type);
        const fileSize = Math.round((file.size / 1024));

        if (fileSize < 5120)
        {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg')
            {
                let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
                let fileName = uuidv1() + '.' + extension;
                const newFile = new File([blob], fileName, { type: file.type });

                state.picture.set(newFile);
                state.src.set(URL.createObjectURL(event.target.files[0]));
            } else
            {
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Upload only .jpg, .jpeg, gif, .png',
                });
            }
        } else
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Upload Below 5mb file',
            });
        }
    };
    return (
        <Box className='contentBox'>
            <Box
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    // m: 1,
                    // p: 1,
                    width: '100%',
                }}
                autoComplete="off">
                <Box>
                    <Box>
                        <Typography
                            variant="h5"
                            fontSize={30}
                            noWrap
                            color="primary"
                            component="div"
                            fontFamily={"Action NBA"}
                            fontWeight={600}
                            textAlign={'center'}
                            p={1}>
                            Upload Branding Image *
                        </Typography>

                        <Typography
                            variant="h4"
                            fontSize={14}
                            sx={{ textAlign: 'center', pb: 1 }}
                            fontWeight={400}
                        >
                            Photo size should be 300px
                        </Typography>
                        <label>
                            {state.src.get() ? ( 
                                <Avatar
                                    alt="event image"
                                    src={state.src.get()}
                                    variant="square"
                                    sx={{
                                        width: 325,
                                        height: 180,
                                        marginLeft: 1,
                                    }}
                                />
                            ) : eventPic ? (  
                                <Avatar
                                    alt="event image"
                                    src={eventPic}
                                    variant="square"
                                    sx={{
                                        width: 325,
                                        height: 180,
                                        marginLeft: 1,
                                    }}
                                />
                            ) : ( 
                                <Box
                                    component="img"
                                    alt="pic."
                                    src={eventUpload}
                                    className={classes.pic}
                                    id="imageUpload"
                                />
                            )}

                            <input
                                type="file"
                                id="imageUpload"
                                accept=".png, .jpg, .jpeg, .gif"
                                hidden
                                onChange={fileUploadHandler}
                            />
                        </label>
                    </Box>
                </Box>
                <Box>
                    <Typography
                        variant="h5"
                        fontSize={30}
                        noWrap
                        //textAlign={'center'}
                        fontFamily={"Action NBA"}
                        color="primary"
                        component="div"
                        fontWeight={600}
                        px={12}
                        py={1}
                    >
                        Color Scheme
                    </Typography>

                    <Box>
                        <Divider
                            sx={{
                                display: {
                                    xs: 'none',
                                    md: 'block',
                                },
                                // marginLeft: 11,
                            }}
                            orientation="vertical"
                            variant="middle"
                            flexItem
                        />
                        <Divider
                            sx={{
                                display: {
                                    xs: 'block',
                                    md: 'none',
                                },
                                py: 2,
                            }}
                            orientation="horizontal"
                            variant="middle"
                            flexItem
                        />

                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    //flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    //px: 8

                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: 220,
                                        //px:10
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={15}
                                        fontWeight={600}
                                        noWrap
                                        component="div"
                                        gutterBottom>
                                        Primary Color
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        // color={color.primary}
                                        style={{
                                            backgroundColor: primaryColor,
                                        }}
                                        className={classes.buttonColor}
                                        onClick={() =>
                                            setShowPrimaryColorPicker(
                                                (showPrimaryColorPicker) =>
                                                    !showPrimaryColorPicker
                                            )
                                        }>
                                        <ColorizeIcon />
                                    </Button>
                                    {showPrimaryColorPicker && (
                                        <ChromePicker
                                            color={primaryColor}
                                            onChange={(updatedColor) =>
                                                setPrimaryColor(
                                                    updatedColor.hex
                                                )
                                            }
                                        />
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: 250,
                                        //px:1
                                    }}>
                                    <Typography
                                        variant="h5"
                                        fontSize={15}
                                        fontWeight={600}
                                        noWrap
                                        component="div"
                                        gutterBottom>
                                        Secondary Color
                                    </Typography>
                                    <Button
                                        className={classes.buttonColor}
                                        variant="contained"
                                        style={{
                                            backgroundColor: secondaryColor,
                                        }}
                                        // color={color.secondary}
                                        onClick={() =>
                                            setShowSecondaryColorPicker(
                                                (showSecondaryColorPicker) =>
                                                    !showSecondaryColorPicker
                                            )
                                        }>
                                        <ColorizeIcon />
                                    </Button>

                                    {showSecondaryColorPicker && (
                                        <ChromePicker
                                            color={secondaryColor}
                                            onChange={(updatedColor) =>
                                                setSecondaryColor(
                                                    updatedColor.hex
                                                )
                                            }
                                        />
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                    }}
                    item>
                    <ButtonContainer
                        handleClick={handleClick}
                        handleCancel={handleCancel}
                        buttonText={'Update'}
                        showLoading={true}
                        loading={loading.get()}
                        disableButton={disableButton.get()}
                    />
                </Box>
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
            </Box>
        </Box>
    );
};

export default BrandingColor;
// {
//     routeProps: {
//         path: RouteConstants.BRANDING_COLOR,
//         component: BrandingColor,
//     },
//     name: 'BrandingColor',
// };
//export default EventDetail;
